import request from '@/utils/request'

/**
 * 智慧大屏-项目列表
 */
export function wisdomProjectList (parameter) {
  return request({
    url: `/org/Organization/wisdomProjectList/${parameter.orgId}/${parameter.type}`,
    method: 'get'
  })
}

/**
 * 气象监测-获取当前租户下的城市信息
 */
export function getCityInfoByOrgId (parameter) {
  return request({
    url: `/org/Organization/getCityInfoByOrgId/${parameter.orgId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 根据组织id查询合同基本信息表详情
 */
export function getContractsByOrgId (parameter) {
  return request({
    url: `/org/Contracts/getContractsByOrgId/${parameter.orgId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 修改合同基本信息表
 */
export function putContractsByOrgId (parameter) {
  return request({
    url: `/org/Contracts/compile`,
    method: 'put',
    data: parameter
  })
}

// --------------------------安全生产方案------------------------------

/**
 * 【安全管理】--【安全生产方案】--列表
 * @param {object} parameter
 * @param {string} search 搜索字段
 */
export function getConstructionPlanList (parameter) {
  return request({
    url: `/org/ConstructionPlan/list`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【安全管理】--【安全生产方案】--列表--删除列表数据
 * @param {object} parameter
 * @param {number} id 列表Id
 */
export function deleteConstructionPlan (parameter) {
  return request({
    url: `/org/ConstructionPlan/${parameter.id}`,
    method: 'delete',
    data: parameter
  })
}
/**
 * 【安全管理】--【安全生产方案】--表单--新增数据
 * @param {object} parameter
 */
export function saveConstructionPlan (parameter) {
  return request({
    url: `/org/ConstructionPlan/`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【安全管理】--【安全生产方案】--表单--修改数据
 * @param {object} parameter
 */
export function updateConstructionPlan (parameter) {
  return request({
    url: `/org/ConstructionPlan/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【安全管理】--【安全生产方案】--表单--查看详情
 * @param {object} parameter
 * @param {number} id 列表Id
 */
export function getConstructionPlan (parameter) {
  return request({
    url: `/org/ConstructionPlan/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

// --------------------------安全生产方案交底------------------------------

/**
 * 【安全管理】--【安全生产方案交底】--列表
 * @param {object} parameter
 * @param {string} search 搜索字段
 */
export function getSchemeClarificationList (parameter) {
  return request({
    url: `/org/SchemeClarification/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【安全管理】--【安全生产方案交底】--查询安全生产方案交底状态分析
 * @param {object} parameter
 */
export function getSchemeStateAnalysis (parameter) {
  return request({
    url: `/org/SchemeClarification/schemeStateAnalysis/${parameter.orgId}`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【安全管理】--【安全生产方案交底】--列表--删除列表数据
 * @param {object} parameter
 * @param {number} id 列表Id
 */
export function deleteSchemeClarification (parameter) {
  return request({
    url: `/org/SchemeClarification/${parameter.id}`,
    method: 'delete',
    data: parameter
  })
}
/**
 * 【安全管理】--【安全生产方案交底】--表单--新增数据
 * @param {object} parameter
 */
export function saveSchemeClarification (parameter) {
  return request({
    url: `/org/SchemeClarification/`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【安全管理】--【安全生产方案交底】--表单--修改数据
 * @param {object} parameter
 */
export function updateSchemeClarification (parameter) {
  return request({
    url: `/org/SchemeClarification/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【安全管理】--【安全生产方案交底】--表单--查看详情
 * @param {object} parameter
 * @param {number} id 列表Id
 */
export function getSchemeClarification (parameter) {
  return request({
    url: `/org/SchemeClarification/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【安全管理】--【安全巡查】--列表
 ** @param {object} parameter
 */
export function getConstructionSiteIssuesList (parameter) {
  return request({
    url: `/org/SafetyInspection/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【安全管理】--【安全巡查】--查询整改状态分析
 ** @param {object} parameter
 */
 export function getSafetyInspectionAnalysis (parameter) {
  return request({
    url: `/org/SafetyInspection/safetyInspectionAnalysis/${parameter.orgId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【安全管理】--【安全巡查】-- 保存
 ** @param {object} parameter
 */
 export function saveSafetyInspection (parameter) {
  return request({
    url: `/org/SafetyInspection/`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【安全管理】--【安全巡查】-- 查看
 ** @param {object} parameter
 */
 export function getSafetyInspection (parameter) {
  return request({
    url: `/org/SafetyInspection/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【安全管理】--【安全巡查】-- 修改
 ** @param {object} parameter
 */
 export function putSafetyInspection (parameter) {
  return request({
    url: `/org/SafetyInspection/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【安全管理】--【安全巡查】-- 删除
 ** @param {object} parameter
 */
 export function deleteSafetyInspection (parameter) {
  return request({
    url: `/org/SafetyInspection/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 根据构件id查询安全巡查列表
 ** @param {object} parameter
 */
 export function getListSafetyInspectionByComponentId (parameter) {
  return request({
    url: `/org/SafetyInspection/listSafetyInspectionByComponentId`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询隐患巡查与整改指派记录表最新一条记录
 ** @param {object} parameter
 */
 export function getLastAssignmentRecordRes (parameter) {
  return request({
    url: `/org/SafetyInspectionAssignmentRecord/getLastAssignmentRecordRes/${parameter.safetyInspectionId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询隐患巡查与整改指派记录表列表
 ** @param {object} parameter
 */
 export function listSafetyInspectionAssignmentRecord (parameter) {
  return request({
    url: `/org/SafetyInspectionAssignmentRecord/listSafetyInspectionAssignmentRecord`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询隐患巡查与整改指派记录表列表
 ** @param {object} parameter
 */
 export function listSafetyInspectionRectificationRecord (parameter) {
  return request({
    url: `/org/SafetyInspectionRectificationRecord/listSafetyInspectionRectificationRecord`,
    method: 'get',
    params: parameter
  })
}

/**
 * 指派隐患巡查
 ** @param {object} parameter
 */
 export function assignSafetyInspection (parameter) {
  return request({
    url: `/org/SafetyInspection/assignSafetyInspection`,
    method: 'post',
    data: parameter
  })
}

/**
 * 整改隐患巡查
 ** @param {object} parameter
 */
 export function rectificationSafetyInspection (parameter) {
  return request({
    url: `/org/SafetyInspection/rectificationSafetyInspection`,
    method: 'post',
    data: parameter
  })
}

/**
 * 验收隐患巡查
 ** @param {object} parameter
 */
 export function acceptanceSafetyInspection (parameter) {
  return request({
    url: `/org/SafetyInspection/acceptanceSafetyInspection`,
    method: 'post',
    data: parameter
  })
}
